import React from 'react';
import './index.css';
import {Message} from "../Message";

export const Container = ({messages}) => {

    return(<div className="chat-container">
        {messages?.map((message) => <Message key={message.id} text={message.text} type={message.type}
                                            status={message.status} datetime={message.created}
                                            attachments={message.attachments}/> )}
    </div>)
}